/**
 * Values taken from existing Bloomreach label keys on 2 March 2022.
 */ const labelKeySuffixes = {
    BANCONTACT_CARD: 'bancontactCard',
    BANCONTACT_MOBILE: 'bancontactMobile',
    CARD: 'creditcard',
    CASH_ON_DELIVERY: 'cashOnDelivery',
    FAKE: 'fake',
    IDEAL: 'ideal',
    KLARNA: 'klarna',
    KLARNA_PAY_NOW: 'klarna_pay_now',
    KLARNA_ACCOUNT: 'klarna_account',
    MBWAY: 'mbway',
    MOBILEPAY: 'mobilepay',
    MULTIBANCO: 'multibanco',
    ONEY: 'oney',
    ONEY_3X: 'oney_3x',
    ONEY_4X: 'oney_4x',
    PAYPAL: 'paypal',
    SEPA: 'sepa',
    SWISH: 'swish',
    APPLE_PAY: 'applePay',
    GOOGLE_PAY: 'googlePay',
    BIZUM: 'bizum'
};
/**
 * Most payment methods are brand names, so they don't need to be translated.
 */ const globalTranslations = {
    BANCONTACT_CARD: 'Bancontact Card',
    BANCONTACT_MOBILE: 'Bancontact Mobile',
    FAKE: 'Fake',
    IDEAL: 'iDEAL',
    KLARNA: 'Klarna',
    KLARNA_PAY_NOW: 'Klarna Pay Now',
    KLARNA_ACCOUNT: 'Klarna Account',
    MBWAY: 'MB WAY',
    MOBILEPAY: 'MobilePay',
    MULTIBANCO: 'Multibanco',
    ONEY: 'Oney',
    ONEY_3X: 'Oney (3x)',
    ONEY_4X: 'Oney (4x)',
    PAYPAL: 'PayPal',
    SEPA: 'SEPA',
    SWISH: 'Swish',
    APPLE_PAY: 'Apple Pay',
    GOOGLE_PAY: 'Google Pay',
    BIZUM: 'Bizum'
};
const getPaymentMethodLabel = (method, intl)=>{
    const labelKey = `account.order.paymentMethod.${labelKeySuffixes[method]}`;
    /**
   * Still offer an OpCo the ability to use a label to override a payment method translation if they want to.
   */ if (intl.hasLabel(labelKey)) {
        return {
            label: intl.getLabel(labelKey),
            value: method
        };
    }
    const globalTranslation = globalTranslations[method];
    if (globalTranslation) {
        return {
            label: globalTranslation,
            value: method
        };
    }
    /**
   * If all else fails, offer a way to inform the user that we don't know the payment method.
   */ return {
        label: intl.getLabel(`account.order.paymentMethod.unknown`),
        value: method
    };
};

export { getPaymentMethodLabel, labelKeySuffixes };
//# sourceMappingURL=get-payment-method-label.js.map
